import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Home, TreePine, Wrench } from 'lucide-react';
import { Button } from './ui/button';

const Services = () => {
  const services = [
    {
      icon: <Home className="w-12 h-12 text-blue-400" />,
      title: 'Permanent Holiday Light Installation',
      description: 'Professional installation of IllumiDEL permanent lights, Celebright alternative, and Gemstone Lights quality systems. 20-year warranty with stunning animations. Better than Costco Christmas lights with smartphone control.',
      features: ['20-Year Warranty', 'Smartphone Control', 'Endless Animations', 'Energy Efficient']
    },
    {
      icon: <TreePine className="w-12 h-12 text-blue-400" />,
      title: 'Professional Tree Lighting',
      description: 'Expert installation of permanent lights on trees up to 60ft tall. Transform your Saskatoon landscape with professional tree wrapping that creates magical ambiance year-round.',
      features: ['Up to 60ft Tall', 'Professional Wrapping', 'Weather Resistant', 'Year-Round Beauty']
    },
    {
      icon: <Wrench className="w-12 h-12 text-blue-400" />,
      title: 'Govee & DIY Hardware Kits',
      description: 'Purchase Govee permanent outdoor lights track, premium aluminum tracks, control boxes, and installation hardware. Get the professional look with expert-grade materials.',
      features: ['Govee Systems', 'Complete Kits', 'Installation Guide', 'Pro-Grade Quality']
    }
  ];

  const scrollToQuote = () => {
    document.getElementById('quote').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPermanentLighting = () => {
    document.getElementById('permanent-lighting-details').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTreeWrapping = () => {
    document.getElementById('tree-wrapping').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToDIY = () => {
    document.getElementById('diy').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Professional lighting solutions for every need and budget
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="hover:shadow-2xl transition-all duration-300 border-none bg-white hover:-translate-y-2">
              <CardHeader>
                <div className="mb-4">{service.icon}</div>
                <CardTitle className="text-2xl mb-2">{service.title}</CardTitle>
                <CardDescription className="text-base">{service.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button 
                  onClick={
                    index === 0 ? scrollToPermanentLighting : 
                    index === 1 ? scrollToTreeWrapping : 
                    scrollToDIY
                  } 
                  className="w-full bg-gray-900 hover:bg-gray-800 text-white"
                >
                  Learn More
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
